import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { QcDashboard } from '../components/qcDashboard';

export const getQcDashboardRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    qcDashboard: {
      path: `${basePath}/post-closing/qc-dashboard`,
      url: `${baseUrl}/post-closing/qc-dashboard`,
      documentTitle: 'Post QC Dashboard',
    },
  };
};

export const getQcDashboardRoutes = (basePath: string, baseUrl: string) => {
  const config = getQcDashboardRoutesConfig(basePath, baseUrl);

  return {
    qcDashboard: (
      <Route exact path={config.qcDashboard.path}>
        <Page routeDefinition={config.qcDashboard}>
          <QcDashboard />
        </Page>
      </Route>
    ),
  };
};
